<template>
  <page>
              <message :messages="messages"></message>
              <form>
                <v-flex xs12>
                  <v-expansion-panels v-model="panel1" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text>
                            <v-container fluid grid-list-sm>
                              <v-layout row wrap>
                                <v-flex xs6>
                                  <v-autocomplete
                                    :items="ageByList"
                                    v-model="reportForm.ageBy"
                                    :label="labels.ageBy"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="ageBy"
                                    :data-vv-as="labels.ageBy"
                                    :error-messages="errors.collect('ageBy')"
                                    v-validate="'required'"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex xs6>
                                  <cal-picker
                                    v-model="reportForm.currMth"
                                    :label="labels.currMth"
                                    v-validate="ageingValidate(0)"
                                    :data-vv-as="labels.currMth"
                                    data-vv-name="currMth"
                                    :error-messages="errors.collect('currMth')"
                                    :max="new Date()"
                                    @change="doDefAgePeriod"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex xs6>
                                  <cal-picker
                                    v-model="reportForm.currLess1"
                                    :label="labels.currLess1"
                                    v-validate="ageingValidate(1)"
                                    :data-vv-as="labels.currLess1"
                                    data-vv-name="currLess1"
                                    :error-messages="errors.collect('currLess1')"
                                    :max="getMaxAgeing(1)"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex xs6>
                                  <cal-picker
                                    v-model="reportForm.currLess2"
                                    :label="labels.currLess2"
                                    v-validate="ageingValidate(2)"
                                    :data-vv-as="labels.currLess2"
                                    data-vv-name="currLess2"
                                    :error-messages="errors.collect('currLess2')"
                                    :max="getMaxAgeing(2)"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex xs6>
                                  <cal-picker
                                    v-model="reportForm.currLess3"
                                    :label="labels.currLess3"
                                    v-validate="ageingValidate(3)"
                                    :data-vv-as="labels.currLess3"
                                    data-vv-name="currLess3"
                                    :error-messages="errors.collect('currLess3')"
                                    :max="getMaxAgeing(3)"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex xs6>
                                  <cal-picker
                                    v-model="reportForm.currLess4"
                                    :label="labels.currLess4"
                                    v-validate="ageingValidate(4)"
                                    :data-vv-as="labels.currLess4"
                                    data-vv-name="currLess4"
                                    :error-messages="errors.collect('currLess4')"
                                    :max="getMaxAgeing(4)"
                                  ></cal-picker>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
                <v-spacer class="mt-3"></v-spacer>
                <v-flex xs12>
                  <v-expansion-panels v-model="panel2" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text>
                            <v-container fluid grid-list-sm>
                              <v-layout row wrap>
                                <v-flex xs6>
                                  <v-autocomplete
                                    :items="interList"
                                    v-model="reportForm.acctNoFrom"
                                    :label="labels.acctNoFrom"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="acctNoFrom"
                                    :data-vv-as="labels.acctNoFrom"
                                    :error-messages="errors.collect('acctNoFrom')"
                                    v-validate="acctNoFromValidate()"
                                    clearable
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex xs6>
                                  <v-autocomplete
                                    :items="interList"
                                    v-model="reportForm.acctNoTo"
                                    :label="labels.acctNoTo"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="acctNoTo"
                                    :data-vv-as="labels.acctNoTo"
                                    :error-messages="errors.collect('acctNoTo')"
                                    v-validate="acctNoToValidate()"
                                    clearable
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex xs6>
                                  <v-autocomplete
                                    :items="ageByList"
                                    v-model="reportForm.dateRangeBy"
                                    :label="labels.dateRangeBy"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="dateRangeBy"
                                    :data-vv-as="labels.dateRangeBy"
                                    :error-messages="errors.collect('dateRangeBy')"
                                    v-validate="'required'"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex xs3>
                                  <cal-picker
                                    v-model="reportForm.fromDate1"
                                    :label="labels.fromDate1"
                                    v-validate="fromDateValidation(reportForm.toDate1)"
                                    :data-vv-as="labels.fromDate1"
                                    data-vv-name="fromDate1"
                                    :error-messages="errors.collect('fromDate1')"
                                    :min="fromDateMinDate"
                                    :max="fromDateMax()"
                                    :disabled="fromToDateDisc"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex xs3>
                                  <cal-picker
                                    v-model="reportForm.toDate1"
                                    :label="labels.toDate1"
                                    v-validate="toDateValidation(reportForm.fromDate1)"
                                    :data-vv-as="labels.toDate1"
                                    data-vv-name="toDate1"
                                    :error-messages="errors.collect('toDate1')"
                                    :min="reportForm.fromDate1"
                                    :max="today"
                                    :disabled="fromToDateDisc"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex xs6>
                                  <v-text-field
                                    v-model="reportForm.acctYr"
                                    type="number"
                                    :label="labels.acctYr"
                                    :error-messages="errors.collect('acctYr')"
                                    data-vv-name="acctYr"
                                    :data-vv-as="labels.acctYr"
                                    v-validate="acctYrValidate()"
                                    :disabled="acctYrMthDisc"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs6>
                                  <v-text-field
                                    v-model="reportForm.acctMth"
                                    type="number"
                                    :label="labels.acctMth"
                                    :error-messages="errors.collect('acctMth')"
                                    data-vv-name="acctMth"
                                    :data-vv-as="labels.acctMth"
                                    v-validate="'required|numeric|min_value:1|max_value:13'"
                                    :disabled="acctYrMthDisc"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs6>
                                  <v-text-field
                                    v-model="reportForm.fund"
                                    :label="labels.fund"
                                    :error-messages="errors.collect('fund')"
                                    data-vv-name="fund"
                                    :data-vv-as="labels.fund"
                                    append-icon="mdi-magnify"
                                    @click:append="getHelpList('fund')"
                                    v-validate="'required'"
                                    readonly
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs6>
                                  <v-text-field
                                    v-model="reportForm.acctNoSfx"
                                    :label="labels.acctNoSfx"
                                    :error-messages="errors.collect('acctNoSfx')"
                                    data-vv-name="acctNoSfx"
                                    :data-vv-as="labels.acctNoSfx"
                                    append-icon="mdi-magnify"
                                    @click:append="getHelpList('suffix')"
                                    readonly
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs6>
                                  <v-autocomplete
                                    :items="stmtTypeList"
                                    v-model="reportForm.stmtType"
                                    :label="labels.stmtType"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="stmtType"
                                    :data-vv-as="labels.stmtType"
                                    :error-messages="errors.collect('stmtType')"
                                    v-validate="'required'"
                                  ></v-autocomplete>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
                <v-spacer class="mt-3"></v-spacer>
                <v-flex xs12>
                  <v-expansion-panels v-model="panel3" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div><v-icon>mdi-settings</v-icon> Document Settings</div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card>
                          <v-card-text>
                            <v-container fluid grid-list-sm>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-checkbox
                                    v-model="reportForm.ageByCommDate"
                                    :label="labels.ageByCommDate"
                                    data-vv-name="ageByCommDate"
                                    :data-vv-as="labels.ageByCommDate"
                                    :disabled="ageByCommDateDisc"
                                  ></v-checkbox>
                                </v-flex>
                                <v-flex xs6>
                                  <v-checkbox
                                    v-model="reportForm.prtUnFuTran"
                                    :label="labels.prtUnFuTran"
                                    data-vv-name="prtUnFuTran"
                                    :data-vv-as="labels.prtUnFuTran"
                                  ></v-checkbox>
                                </v-flex>
                                <v-flex xs6>
                                  <v-checkbox
                                    v-model="reportForm.rptByBrn"
                                    :label="labels.rptByBrn"
                                    data-vv-name="rptByBrn"
                                    :data-vv-as="labels.rptByBrn"
                                  ></v-checkbox>
                                </v-flex>
                                <v-flex xs6>
                                  <v-text-field
                                    v-model="reportForm.branch"
                                    :label="labels.branch"
                                    :error-messages="errors.collect('branch')"
                                    data-vv-name="branch"
                                    :data-vv-as="labels.branch"
                                    append-icon="mdi-magnify"
                                    @click:append="getHelpList('branch')"
                                    v-validate="'required'"
                                    readonly
                                    :disabled="!reportForm.rptByBrn"
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
              </form>
        <v-dialog v-model="helplist" width="900px" persistent>
          <helplist :apiURI="apiURI" :mode="mode" :param="param" @close="doClose" @doAssign="doAssign($event)"></helplist>
        </v-dialog>
                                <v-flex lg6 xs12>
                                  <v-checkbox
                                    v-model="reportForm.printRptRunTime"
                                    :label="labels.printRptRunTime"
                                    data-vv-name="printRptRunTime"
                                    :data-vv-as="labels.printRptRunTime"
                                  ></v-checkbox>
                                </v-flex>
                <v-flex xs12 class="pt-3">
                  <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                    <v-icon left dark>mdi-file-export</v-icon>
                    {{ labels.export }}
                  </v-btn>
                  <v-btn-toggle dense mandatory v-model="reportForm.format">
                    <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                      <span>{{ format.label }}</span>
                      <v-icon :color="format.color">{{ format.icon }}</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-flex>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import Helplist from '../Helplist'
import { ageByList, stmtTypeList, acctNoRangeFrom, acctNoRangeTo, checkDateRangeFrom, checkDateRangeTo, checkCurrMth, checkAgeing } from './index'

export default {
  data() {
    return {
      labels: {
        ageBy: 'Age By',
        currMth: 'Current Month',
        currLess1: 'Current Less 1',
        currLess2: 'Current Less 2',
        currLess3: 'Current Less 3',
        currLess4: 'Current Less 4',
        acctNoFrom: 'Group Account No. From',
        acctNoTo: 'Group Account No. To',
        dateRangeBy: 'Date Range By',
        fromDate1: 'From',
        toDate1: 'To',
        acctYr: 'Accounting Year',
        acctMth: 'Accounting Month',
        fund: 'Fund',
        acctNoSfx: 'Suffix',
        stmtType: 'Statement Type',
        ageByCommDate: 'Age by Commencement Date - only for Direct Inward Debit / Credit',
        prtSumList: 'Print Summary List',
        prtUnFuTran: 'Print Undue/Future Tran',
        rptByBrn: 'Report By Branch',
        branch: 'Branch',
        format: 'Export Format',
        export: 'Export to',
        printRptRunTime: 'Print Runtime Parameters'
      },
      reportForm: {
        ageBy: 'A',
        currMth: new Date(),
        currLess1: null,
        currLess2: null,
        currLess3: null,
        currLess4: null,
        acctNoFrom: null,
        acctNoTo: null,
        dateRangeBy: 'T',
        fromDate1: null,
        toDate1: null,
        acctYr: null,
        acctMth: null,
        fund: 'All',
        acctNoSfx: 'All',
        stmtType: 'O',
        ageByCommDate: true,
        prtSumList: false,
        prtUnFuTran: false,
        rptByBrn: false,
        branch: 'All',
        format: undefined,
        sendEmail: false,
        printRptRunTime: true
      },
      // HelpList
      helplist: false,
      apiURI: '',
      mode: '',
      param: '',
      defAcctYr: null,
      defFromDate: null,
      defToDate: null,
      fromToDateDisc: false,
      acctYrMthDisc: true,
      ageByCommDateDisc: true,
      fromDateMinDate: new Date(2000, 0, 1),
      today: new Date(),
      maxAcctYr: 0,
      interList: [],
      ageByList: [],
      stmtTypeList: [],
      menu: {},
      supportedFormat: [],
      submitting: false,
      panel1: [0],
      panel2: [0],
      panel3: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    },
    'reportForm.ageBy': function (value) {
      if (value === 'A') {
        this.getAcctPeriod()
      } else {
        this.reportForm.currMth = new Date()
      }

      if (value === 'C') {
        this.ageByCommDateDisc = false
      } else {
        this.ageByCommDateDisc = true
      }
    },
    'reportForm.dateRangeBy': function (value) {
      if (value === 'A') {
        this.fromToDateDisc = true
        this.reportForm.acctYr = this.defAcctYr
        this.acctYrMthDisc = false
        this.reportForm.fromDate1 = null
        this.reportForm.toDate1 = null
      } else {
        this.fromToDateDisc = false
        this.reportForm.acctYr = null
        this.reportForm.acctMth = null
        this.acctYrMthDisc = true
        this.reportForm.fromDate1 = this.defFromDate
        this.reportForm.toDate1 = this.defToDate
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.accountReports.init !== 1) {
          await this.$store.dispatch('accountReportsInit')
        }
        const apiURI = this.rptMenu.SOAUOI
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
        this.getInterList()
        this.getAcctPeriod()
        this.getCompany()
        this.doDefAgePeriod()
      } catch (err) {
        throw err
      }
    },
    doDefAgePeriod() {
      for (let i = 0; i <= 5; i++) {
        var day = this.reportForm.currMth.getDate()
        var month = this.reportForm.currMth.getMonth()
        var year = this.reportForm.currMth.getFullYear()
        var a = new Date(year, month, day)
        a.setMonth(a.getMonth() - i)
        this.reportForm['currLess' + i] = a
      }
    },
    async getInterList() {
      const apiURI = this.menu.getInterList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          data.map((inter) => {
            const convertList = {
              label: inter.value + ' - ' + inter.label,
              value: inter.value
            }
            this.interList.push(convertList)
          })
        }
      }
    },
    async getAcctPeriod() {
      const apiURI = this.menu.getAcctPeriod
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.reportForm.currMth = new Date(data.acctPeriod.acctPerYr, data.acctPeriod.acctPerMth, 0)
          this.reportForm.currLess1 = new Date(data.acctPeriod.acctPerYr, data.acctPeriod.acctPerMth - 1, 0)
          this.reportForm.currLess2 = new Date(data.acctPeriod.acctPerYr, data.acctPeriod.acctPerMth - 2, 0)
          this.reportForm.currLess3 = new Date(data.acctPeriod.acctPerYr, data.acctPeriod.acctPerMth - 3, 0)
          this.reportForm.currLess4 = new Date(data.acctPeriod.acctPerYr, data.acctPeriod.acctPerMth - 4, 0)
        }
      }
    },
    async getCompany() {
      const apiURI = this.menu.getCompany
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.defFromDate = new Date(data.company.currAcctYr, 0, 1)
          this.defToDate = new Date(data.company.currAcctYr, 11, 31)
          // this.reportForm.acctYr = data.company.currAcctYr
          this.defAcctYr = data.company.currAcctYr
          this.maxAcctYr = data.company.currAcctYr + 1
        }
      }
    },
    acctNoFromValidate() {
      if (this.reportForm.acctNoFrom === null && this.reportForm.acctNoTo !== null) {
        return 'required'
      } else {
        return 'acctNoRangeFrom:' + this.reportForm.acctNoTo
      }
    },
    acctNoToValidate() {
      if (this.reportForm.acctNoFrom !== null && this.reportForm.acctNoTo === null) {
        return 'required'
      } else {
        return 'acctNoRangeTo:' + this.reportForm.acctNoFrom
      }
    },
    fromDateMax() {
      if (this.reportForm.toDate1) {
        return this.reportForm.toDate1
      } else {
        return new Date(2070, 11, 31)
      }
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'checkDateRangeFrom:' + toDate1
      } else {
        return 'checkDateRangeFrom'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'checkDateRangeTo:' + fromDate1
      } else {
        return 'checkDateRangeTo'
      }
    },
    acctYrValidate() {
      return 'required|numeric|min_value:' + 2000 + '|max_value:' + this.maxAcctYr
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      if (fieldName === 'branch') {
        this.apiURI = this.menu.getBranchList
        this.param = this.reportForm.branch
      } else if (fieldName === 'fund') {
        this.apiURI = this.menu.getFundList
        this.param = this.reportForm.fund
      } else {
        this.apiURI = this.menu.getAcctNoSfxList
        this.param = this.reportForm.acctNoSfx
      }
      this.helplist = true
    },
    doClose() {
      this.helplist = false
    },
    doAssign(Obj) {
      if (this.mode === 'branch') {
        this.reportForm.branch = ''
        this.reportForm.branch = Obj.finalSelectedItems.toString()
      } else if (this.mode === 'fund') {
        this.reportForm.fund = ''
        this.reportForm.fund = Obj.finalSelectedItems.toString()
      } else {
        this.reportForm.acctNoSfx = ''
        this.reportForm.acctNoSfx = Obj.finalSelectedItems.toString()
      }
      this.brnHelplist = false
      this.fundHelplist = false
      this.acctNoSfxHelplist = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    ageingValidate(period) {
      var valStr = 'required'
      if (period === 0) {
        valStr = valStr + '|checkCurrMth'
      } else if (period === 1) {
        if (this.reportForm.currMth) {
          valStr = valStr + '|checkAgeing:' + this.reportForm.currMth
        }
      } else if (period === 2) {
        if (this.reportForm.currLess1) {
          valStr = valStr + '|checkAgeing:' + this.reportForm.currLess1
        }
      } else if (period === 3) {
        if (this.reportForm.currLess2) {
          valStr = valStr + '|checkAgeing:' + this.reportForm.currLess2
        }
      } else if (period === 4) {
        if (this.reportForm.currLess3) {
          valStr = valStr + '|checkAgeing:' + this.reportForm.currLess3
        }
      } else if (period === 5) {
        if (this.reportForm.currLess4) {
          valStr = valStr + '|checkAgeing:' + this.reportForm.currLess4
        }
      }
      return valStr
    },
    getMaxAgeing(period) {
      if (this.reportForm.ageBy !== 'A') {
        switch (period) {
          case 1:
            return this.reportForm.currMth
          case 2:
            return this.reportForm.currLess1
          case 3:
            return this.reportForm.currLess2
          case 4:
            return this.reportForm.currLess3
          case 5:
            return this.reportForm.currLess4
        }
      }
    }
  },
  created() {
    this.doInit()
    this.ageByList = ageByList
    this.stmtTypeList = stmtTypeList
    this.$validator.extend('acctNoRangeFrom', acctNoRangeFrom)
    this.$validator.extend('acctNoRangeTo', acctNoRangeTo)
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
    this.$validator.extend('checkCurrMth', checkCurrMth)
    this.$validator.extend('checkAgeing', checkAgeing)
  },
  mixins: [MessageMixin],
  components: {
    Helplist
  }
}
</script>
